/* eslint-disable no-useless-return */
/* eslint-disable camelcase */
/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-template */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-globals */
import { Alert } from './Alert';

class Product {
  constructor({ config, classes }) {
    if (!config) {
      throw Error('Product config is reqired!');
    }
    this.config = {
      ...config,
    };
    this.classes = {
      productForm: '.projector__form',
      productQuantity: '.projector__quantity .--quantity',
      productFormSubmit: '.projector__submit',
      productPrice: '.projector__price.--price',
      productMaxPrice: '.projector__price.--max-price',
      productSave: '.projector__promo-price .--brackets',
      productAvailability: '.projector__availability',
      productAvailabilityIcon: '.projector__availability img',
      productAvailabilityStatus: '.projector__availability strong',
      productAvailabilityValue: '.projector__availability span:last-child',
      productDelivery: '.projector__delivery .--delivery',
      productQuantityLess: '.projector__quantity .--less',
      productQuantityMore: '.projector__quantity .--more',
      productSizes: '.projector__sizes .--size',
      productSize: '#projector_size_hidden',
      productUnitAmount: '.projector__price-unit__amount',
      ...classes,
    };

    // creating object handling queries
    this.nodes = {
      form: document.querySelector(this.classes.productForm),
      quantity: document.querySelector(this.classes.productQuantity),
      quantityLess: document.querySelector(this.classes.productQuantityLess),
      quantityMore: document.querySelector(this.classes.productQuantityMore),
      price: document.querySelector(this.classes.productPrice),
      maxPrice: document.querySelector(this.classes.productMaxPrice),
      save: document.querySelector(this.classes.productSave),
      availability: document.querySelector(this.classes.productAvailability),
      availabilityIcon: document.querySelector(this.classes.productAvailabilityIcon),
      availabilityStatus: document.querySelector(this.classes.productAvailabilityStatus),
      availabilityValue: document.querySelector(this.classes.productAvailabilityValue),
      delivery: document.querySelector(this.classes.productDelivery),
      size: document.querySelector(this.classes.productSize),
      sizes: Array.from(document.querySelectorAll(this.classes.productSizes)),
      unitAmount: document.querySelector(this.classes.productUnitAmount),
    };

    this.days = [
      Literals.projector.deliveryInstant,
      Literals.projector.deliveryMonday,
      Literals.projector.deliveryTuesday,
      Literals.projector.deliveryWednesday,
      Literals.projector.deliveryThursday,
      Literals.projector.deliveryFriday,
      Literals.projector.deliverySaturday,
      Literals.projector.deliverySunday,
    ];

    this.lowestPriceDataCache = false;

    this.init();
  }

  init() {
    this.eventsRemove();
    this.eventsAdd();
    /** prepareSizes było zakomentowane */
    this.prepareSizes();
    this.omnibus();
  }

  prepareSizes() {
    const { sizes } = this.config;

    if(Object.keys(sizes).length === 1) {
      this.currentSize = this.getSize(Object.keys(sizes)[0]);
    }

    /** Poprzednia wersja kodu */
    // const { sizes } = this.config;
    // this.nodes.sizes.forEach((size) => {
    //   let sizeObj = sizes[size.dataset['size']];
    //   sizeObj.node = size;
    //   if (parseInt(sizeObj.amount) == 0) {
    //     size.classList.add('--disabled');
    //   }
    // });
    // if (sizes.onesize) {
    //   this.setSize('onesize');
    // } else {
    //   Object.values(sizes)
    //     .filter((size) => {
    //       return parseInt(size.amount) != 0;
    //     })[0]
    //     .node.dispatchEvent(new Event('click'));
    // }
  }

  update() {
    const { price } = this.config;
    const { availability, shipping_time } = this.currentSize;

    // PRICE
    if (price.worth) {
      this.recalculate(this.nodes.quantity.value, { worth: price.worth });
    }
    if (price.maxprice) {
      this.recalculate(this.nodes.quantity.value, { maxprice: price.maxprice });
    }
    if (price.yousave) {
      this.recalculate(this.nodes.quantity.value, { yousave: price.yousave });
    }

    // AVAILABILITY
    if (availability) {
      this.nodes.form.setAttribute('data-availability', availability.status);
      this.nodes.availabilityIcon.src = availability.status_gfx;
      this.nodes.availabilityValue.innerHTML = availability.status_description;

      switch (availability.status) {
        case 'enable':
          this.nodes.availabilityStatus.innerHTML = Literals.projector.statusEnable;
          break;
        case 'disable':
          this.nodes.availabilityStatus.innerHTML = Literals.projector.statusDisable;
          break;
        case 'order':
          this.nodes.availabilityStatus.innerHTML = Literals.projector.statusOrder;
          break;
        default:
          break;
      }

      this.nodes.delivery.innerHTML = this.shippingTime({ availability, shipping_time });
    }
  }

  // TODO - sprawdzać availability dla niedostępnych
  shippingTime({ shipping_time, availability }) {
    let shippingResult = '';
    let shippingDay = '';

    if (shipping_time) {
      shippingResult = Literals.projector.deliveryTime;

      // eslint-disable-next-line eqeqeq
      if (typeof shipping_time.week_day != 'undefined') {
        if (shipping_time.today === 'true') {
          shipping_time.week_day = 0;
        }
        const weekDay = parseInt(shipping_time.week_day, 10);
        const weekAmount = parseInt(shipping_time.week_amount, 10);

        if (weekAmount === 0) {
          return `${shippingResult} ${this.days[weekDay]}`;
        }
      }
      if (shipping_time.days === 0) {
        shippingDay = this.days[weekDay];
      }
      if (shipping_time.days === '1') {
        shippingDay = Literals.projector.deliveryTomorrow;
      }
    }
    return `${shippingResult} ${shippingDay}`;
  }

  recalculate(value, prices) {
    const { worth, maxprice, yousave } = prices;
    if (this.nodes.price && worth) {
      this.nodes.price.innerHTML = this.formatPrice(value * worth);
    }
    if (this.nodes.maxPrice && maxprice) {
      this.nodes.maxPrice.innerHTML = this.formatPrice(value * maxprice);
    }
    if (this.nodes.save && yousave) {
      this.nodes.save.innerHTML = this.formatPrice(value * yousave);
    }
    if (this.nodes.unitAmount) {
      this.nodes.unitAmount.innerHTML = this.nodes.unitAmount.dataset.amount = value;
    }
  }

  eventsAdd() {
    // this.nodes.form.addEventListener('submit', (e) => this.submit(e));
    this.nodes.quantity.addEventListener('change', (e) => this.changeQuantity(e));
    this.nodes.quantity.addEventListener('click', (e) => this.clickQuantity(e));
    this.nodes.quantity.addEventListener('keyup', (e) => this.keyUpDebounce(e));

    this.nodes.quantityLess.addEventListener('click', () => this.clickUpdateQuantity('less'));
    this.nodes.quantityMore.addEventListener('click', () => this.clickUpdateQuantity('more'));

    this.nodes.sizes.map((size) => {
      size.addEventListener('click', (e) => this.setSize(e.target.dataset['size']));
    });
  }

  eventsRemove() {
    // this.nodes.form.removeEventListener('submit', (e) => this.submit(e));
    this.nodes.quantity.removeEventListener('change', (e) => this.changeQuantity(e));
    this.nodes.quantity.removeEventListener('click', (e) => this.clickQuantity(e));
    this.nodes.quantity.removeEventListener('keyup', (e) => this.keyUpDebounce(e));

    this.nodes.quantityLess.removeEventListener('click', () => this.clickUpdateQuantity('less'));
    this.nodes.quantityMore.removeEventListener('click', () => this.clickUpdateQuantity('more'));
  }

  submitForm(event) {
    if (this.error) {
      event.preventDefault();
    }
  }

  getSize(size) {
    return this.config.sizes[size] ? this.config.sizes[size] : null;
  }

  setSize(size) {
    this.currentSize = this.getSize(size);
    this.nodes.size.value = size;
    this.nodes.sizes.map((size) => {
      size.classList.remove('--active');
    });
    let currentSizeButton = this.nodes.sizes.filter((size) => {
      return size.dataset['size'] === this.currentSize.type;
    });
    if (currentSizeButton.length) {
      currentSizeButton[0].classList.add('--active');
    }
    this.update();
  }

  formatPrice(price, config) {
    if (!price) {
      throw Error('You must set price as parameter!');
    }

    const obj = config || this.config;
    const {
      currency,
      currencySpace,
      currencyBeforeValue,
      currencyGroupSeparator,
      currencyDecimalSeparator,
      currencyFormat,
    } = obj;

    let v = price;
    let m = currencyFormat || '###&nbsp;##0,00';

    if (currencyGroupSeparator) {
      m = m.replace(',', currencyGroupSeparator);
    }
    if (currencyDecimalSeparator) {
      m = m.replace('.', currencyDecimalSeparator);
    }
    if (!m || isNaN(+v)) {
      return v;
    }
    v = m.charAt(0) === '-' ? -v : +v;
    const isNegative = v < 0 ? (v = -v) : 0;
    const result = m.match(/[^\d\-\+#]/g);
    const Decimal = (result && result[result.length - 1]) || '.';
    const Group = (result && result[1] && result[0]) || ',';
    const mn = m.split(Decimal);
    v = v.toFixed(mn[1] && mn[1].length);
    v = +v + '';
    const postrailZero = mn[1] && mn[1].lastIndexOf('0');
    const part = v.split('.');
    if (!part[1] || (part[1] && part[1].length <= postrailZero)) {
      v = (+v).toFixed(postrailZero + 1);
    }
    const szSep = mn[0].split(Group);
    mn[0] = szSep.join('');
    const pozLeadZero = mn[0] && mn[0].indexOf('0');
    if (pozLeadZero > -1) {
      while (part[0].length < mn[0].length - pozLeadZero) {
        part[0] = '0' + part[0];
      }
    } else if (+part[0] == 0) {
      part[0] = '';
    }
    v = v.split('.');
    v[0] = part[0];
    const posSeparator = szSep[1] && szSep[szSep.length - 1].length;
    if (posSeparator) {
      const integer = v[0];
      let str = '';
      const offset = integer.length % posSeparator;
      for (let i = 0, l = integer.length; i < l; i++) {
        str += integer.charAt(i);
        if (!((i - offset + 1) % posSeparator) && i < l - posSeparator) {
          str += Group;
        }
      }
      v[0] = str;
    }
    v[1] = m[1] && v[1] ? Decimal + v[1] : '';
    const newPrice = (isNegative ? '-' : '') + v[0] + v[1];
    return currencyBeforeValue === 'true'
      ? `${currency}${currencySpace ? ' ' : ''}${newPrice}`
      : `${newPrice}${currencySpace ? ' ' : ''}${currency}`;
  }

  clickQuantity(event) {
    this.config.previewQuantityValue = event.target.value;
  }

  keyUpDebounce(event) {
    clearTimeout(this.config.keyUpTimeout);
    this.config.keyUpTimeout = setTimeout(() => {
      this.changeQuantity(event);
    }, 500);
  }

  clickUpdateQuantity(type) {
    if (!this.currentSize) {
      Alert.show({ text: Literals.alerts.chooseSize, mod: '--info', duration: 5000 });
      return;
    }
    const quantityValue = Number(this.nodes.quantity.value);
    const { amount } = this.currentSize;
    const { unitSellBy, price } = this.config;

    switch (type) {
      case 'less':
        if (quantityValue > 0 && quantityValue - unitSellBy < Number(unitSellBy)) {
          Alert.show({ text: `${Literals.alerts.minimumValue} ${unitSellBy}`, mod: '--info', duration: 2500 });
          return;
        }

        this.nodes.quantity.value = quantityValue - Number(unitSellBy);
        this.recalculate(this.nodes.quantity.value, price);

        return;
      case 'more':
        if (Number(amount) >= 0 && quantityValue + Number(unitSellBy) > Number(amount)) {
          Alert.show({ text: `${Literals.alerts.maximumValue} ${amount}`, mod: '--info', duration: 2500 });
          return;
        }

        this.nodes.quantity.value = quantityValue + Number(unitSellBy);
        this.recalculate(this.nodes.quantity.value, price);

        break;
      default:
        return;
    }
  }

  changeQuantity(event) {
    if (!this.currentSize) {
      Alert.show({ text: Literals.alerts.chooseSize, mod: '--info', duration: 5000 });
    }

    clearTimeout(this.config.keyUpTimeout);

    const userValue = Number(event.target.value);
    const { amount } = this.currentSize;
    const { unitSellBy, price } = this.config;

    if (userValue < Number(unitSellBy)) {
      Alert.show({ text: `${Literals.alerts.minimumValue} ${unitSellBy}`, mod: '--info', duration: 2500 });
      event.target.value = this.config.previewQuantityValue;
    } else if (userValue > Number(amount)) {
      Alert.show({ text: `${Literals.alerts.maximumValue} ${amount}`, mod: '--info', duration: 2500 });
      event.target.value = this.config.previewQuantityValue;
    } else if (userValue % Number(unitSellBy)) {
      Alert.show({ text: `${Literals.alerts.sellBy} ${unitSellBy}`, mod: '--info', duration: 2500 });
      event.target.value = this.config.previewQuantityValue;
    } else {
      this.config.previewQuantityValue = event.target.value.replace(',', '.');
      this.recalculate(event.target.value, price);
    }

    return false;
  }

  updateLowestPrice(lowestPriceData) {
    const priceType = 'gross';

    if (!lowestPriceData.sizes.length) return false;
    const lowestPriceElement = document.querySelector('.projector_lowest_price');
    const lowestPriceValueElement = document.querySelector('.projector_lowest_price__value');
    const currentSize = document.querySelector('#projector_size_hidden').value == 'onesize' ? 'uniw' : document.querySelector('#projector_size_hidden').value;
    if (currentSize) { // Wybrany rozmiar
        lowestPriceValueElement.textContent = lowestPriceData.sizes.filter((size) => size.id === currentSize)[0]?.price[priceType]?.formatted;
    } else {
        const highestPrice = lowestPriceData.sizes.reduce((prev, current) => (prev.price[priceType].value < current.price[priceType].value ? current : prev));
        const lowestPrice = lowestPriceData.sizes.reduce((prev, current) => (prev.price[priceType].value > current.price[priceType].value ? current : current));
        // Zakres cen
        if (lowestPrice.price[priceType].value !== highestPrice.price[priceType].value) {
            lowestPriceValueElement.textContent = lowestPrice.price[priceType].formatted + ' - ' + highestPrice.price[priceType].formatted;
        } else { // Jedna cena
            lowestPriceValueElement.textContent = lowestPrice.price[priceType].formatted;
        }
    }

    if (lowestPriceValueElement.textContent !== '') {
        lowestPriceElement.classList.add('--active');
    } else {
        lowestPriceElement.classList.remove('--active');
    }
  }

  omnibus() {
    const that = this;
    const getLowestPrice = async (lowestPriceInput) => {
      const lowestPriceQuery = JSON.stringify({
        query: `query {
          getLastLowestProductPrices(${lowestPriceInput}) {
            id
            sizes {
              id
              price {
                gross {
                  value
                  currency
                  formatted
                }
              }
            }
          }
        }`,
      });

      try {
        const response = await fetch('/graphql/v1/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: lowestPriceQuery,
        });
        const dataJson = await response.json();
        return dataJson;
      } catch (error) {
        console.error('AJAX fetchLastLowestProductPrices() Error:', error);
        return false;
      }
    };

    const lowestPrice = async () => {
        const lowestPriceElement = document.querySelector('.projector_lowest_price');
        if (lowestPriceElement && !lowestPriceElement.classList.contains('--loading')) {
            lowestPriceElement.classList.add('--loading');
            if (!that.lowestPriceDataCache) {
                const changeDate = lowestPriceElement.getAttribute('data-change-date');
                const productId = document.getElementById('projector_product_hidden').getAttribute('value');
                let lowestPriceData = await getLowestPrice(`lastLowestPricesInput: [{
                    date: "${changeDate}",
                    productId: ${productId},
                }]`);
                if (lowestPriceData?.data?.getLastLowestProductPrices) {
                    that.updateLowestPrice(lowestPriceData.data.getLastLowestProductPrices[0]);
                    that.lowestPriceDataCache = lowestPriceData.data.getLastLowestProductPrices[0];
                }
            } else {
                that.updateLowestPrice(that.lowestPriceDataCache);
            }
            lowestPriceElement.classList.remove('--loading');
        }
    };

    lowestPrice();
  }
}

export default Product;
